import { theme } from "../../theme";

const pulseKeyframes = `
@keyframes skeleton-pulse {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.8; }
}
`;

export default function SkeletonCard() {
  return (
    <>
      <style>{pulseKeyframes}</style>
      <div style={{
        background: theme.card, borderRadius: 16, overflow: "hidden",
        border: `1px solid ${theme.border}`,
      }}>
        {/* Image placeholder */}
        <div style={{ height: 160, background: theme.inputBg, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
        <div style={{ padding: "14px 16px 16px" }}>
          {/* Title */}
          <div style={{ height: 18, width: "70%", background: theme.inputBg, borderRadius: 8, marginBottom: 10, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
          {/* Description */}
          <div style={{ height: 14, width: "90%", background: theme.inputBg, borderRadius: 6, marginBottom: 6, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
          <div style={{ height: 14, width: "60%", background: theme.inputBg, borderRadius: 6, marginBottom: 12, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
          {/* Footer */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ height: 14, width: "40%", background: theme.inputBg, borderRadius: 6, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
            <div style={{ height: 14, width: "20%", background: theme.inputBg, borderRadius: 6, animation: "skeleton-pulse 1.5s ease-in-out infinite" }} />
          </div>
        </div>
      </div>
    </>
  );
}
